'use strict';

export class fieldModel
{
	key = null;
	type = 'read';
	title = '';
	limitOn = false;
	limit = 0;
	mandatory = false;
	explain = null;
	
	meta = {
		id: null,
		invitation_id: null,
		section: null,
		ord: null,
		active: false,
		structure_id: null
	};
	
	constructor(fieldData){
		this.setupField(fieldData);
	}
	
	setupField(data){
		if(typeof(data.name) !== 'undefined'){
			this.key = data.name;
		}
		if(typeof(data.type) !== 'undefined'){
			this.type = data.type;
		}
		if(typeof(data.title) !== 'undefined'){
			this.title = data.title;
		}
		if(typeof(data.limit_on) !== 'undefined' && (data.limit_on === 1 || data.limit_on === '1' || data.limit_on === true || data.limit_on === 'true')){
			this.limitOn = true;
		}
		if(typeof(data.limit) !== 'undefined' && !isNaN(data.limit) && data.limit > 0){
			this.limit = parseInt(data.limit);
		}
		if(typeof(data.mandatory) !== 'undefined' && (data.mandatory === 1 || data.mandatory === '1' || data.mandatory === true || data.mandatory === 'true')){
			this.mandatory = true;
		}
		if(typeof(data.explain) !== 'undefined' && data.explain !== ''){
			this.explain = data.explain;
		}
		if(typeof(data.id) !== 'undefined'){
			this.meta.id = data.id;
		}
		if(typeof(data.invitation_id) !== 'undefined'){
			this.meta.invitation_id = data.invitation_id;
		}
		if(typeof(data.section) !== 'undefined'){
			this.meta.section = data.section;
		}
		if(typeof(data.ord) !== 'undefined'){
			this.meta.ord = data.ord;
		}
		if(typeof(data.structure_id) !== 'undefined'){
			this.meta.structure_id = data.structure_id;
		}
		if(typeof(data.active) !== 'undefined' && (data.active === 1 || data.active === '1' || data.active === true || data.active === 'true')){
			this.meta.active = true;
		}
	}
}
